<template>
  <div class="form-work-one">
    <top-main :listArea="listArea" :formWorkTitle="name"></top-main>
    <general-situation :landList="landList"></general-situation>
    <area-maim :areaInfo="areaInfo" v-if="monitorIndex != null"></area-maim>

    <list-main
      :areaCheckList="areaCheckList"
      :editId="editId"
      :outerId="outerId"
      :parkCode="parkCode"
      :countyCode="countyCode"
    ></list-main>
    <!-- <div class="regular-content">
      <div class="regular-content-item">
        <i class="el-icon-s-order icon-color"></i>
      </div>
      <div class="regular-content-item">
        <i class="el-icon-phone icon-color"></i>
      </div>
      <div class="regular-content-item" @click="toTop">
        <img
          style="width: 20px"
          :src="require('@/assets/images/tools/fanhuidingbu.png')"
          alt=""
        />
      </div>
    </div> -->
    <div class="monitor-list">
      <!-- 上边按钮 -->
      <div class="btn" @click="scrollBottom">
        <i class="el-icon el-icon-arrow-up" />
      </div>
      <!-- 中间列表 -->
      <div id="list-box" class="list-box">
        <div id="list" class="list">
          <div
            class="list-item"
            @click="monitor(index)"
            :class="monitorIndex == null ? 'monitorClass' : ''"
          >
            全部
          </div>
          <div
            @click="monitor(index)"
            :class="monitorIndex === index ? 'monitorClass' : ''"
            v-for="(item, index) in monitorList"
            :key="index"
            class="list-item"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <!-- 下边按钮 -->
      <div class="btn" @click="scrollTop">
        <i class="el-icon el-icon-arrow-down" />
      </div>
    </div>
  </div>
</template>

<script>
import topMain from "@/components/formWorkOne/topMain.vue";
import generalSituation from "@/components/formWorkOne/generalSituation.vue";
import areaMaim from "@/components/formWorkOne/areaMaim.vue";
import listMain from "@/components/formWorkOne/listMain.vue";
import { newPromotionEdit } from "@/api/common";
export default {
  name: "formWorkOne",
  components: {
    topMain,
    generalSituation,
    areaMaim,
    listMain,
  },
  // props: ["landList", "listArea", "name"],
  data() {
    return {
      //monitorList:['城市核心区','城南片区','城北片区','沿江片区','温泉片区','高铁片区','马龙片区','城市核心区','城南片区','城北片区','沿江片区','温泉片区','高铁片区3','高铁片区3','高铁片区3','高铁片区3','高铁片区3','高铁片区3','高铁片区11'],
      monitorList: [],
      monitorIndex: null,
      outerId: null,
      topDistance: 0,
      times: 0,
      areaInfo: {}, //选中片区
      areaCheckList: [], //选中片区对应地块
      name: "",
      landList: "",
      listArea: "",
      editId: "",
      countyCode: "",
      parkCode: "",
    };
  },
  watch: {
    listArea: {
      handler(newVal) {
        if (!!newVal) {
          this.monitorList = newVal;
          this.monitorIndex = null;
          // this.monitorIndex = 0;
        }
      },
      deep: true,
      immediate: true,
    },
    monitorIndex: {
      handler(newVal, oldVal) {
        if (newVal != null) {
          this.areaInfo = this.monitorList[newVal];
          // if (
          //   this.monitorList[newVal].checkList &&
          //   this.monitorList[newVal].checkList.length > 0
          // ) {
          //   this.areaCheckList = JSON.parse(
          //     JSON.stringify(this.monitorList[newVal].checkList)
          //   );
          // } else {
          //   this.areaCheckList = [];
          // }
        } else {
          // this.areaCheckList = [];
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.editId = this.$route.query.id;
    this.newPromotionEdit();
    // 滚动时时监听
    // let htmlDom = document.getElementById("list");
    // htmlDom.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    // 获取数据
    newPromotionEdit() {
      newPromotionEdit(this.editId).then((res) => {
        if (res.data.success) {
          let data = res.data.data;
          this.name = data.name;
          this.landList = data.landList;
          this.listArea = data.listArea;
          this.parkCode = data.parkCode;
          this.countyCode = data.county;
          console.log(
            this.name,
            this.landList,
            this.listArea,
            "--------------"
          );
        }
      });
    },
    // 点击查询
    monitor(index) {
      if (index >= 0) {
        this.outerId = this.monitorList[index].id;
        this.monitorIndex = index;
      } else {
        this.outerId = "";
        this.monitorIndex = null;
      }
    },
    //回到顶部
    toTop() {
      this.$nextTick(() => {
        let app = document.getElementsByClassName("form-work-one")[0];
        let top = app.scrollTop;
        const timeTop = setInterval(() => {
          app.scrollTop = app.scrollTop = top -= 10;
          if (top <= 0) {
            clearInterval(timeTop);
          }
        }, 10);
      });
    },
    // 下滑动逻辑
    scrollBottom() {
      // 获取html元素
      let htmlDom = document.getElementById("list");
      const clientHeight = htmlDom.clientHeight;
      const scrollTop = htmlDom.scrollTop;
      const scrollHeight = htmlDom.scrollHeight;
      if (clientHeight + scrollTop !== scrollHeight) {
        this.topDistance += 30;
        // 设置滚动行为改为平滑的滚动
        htmlDom.scrollTo({
          top: this.topDistance,
          behavior: "smooth",
        });
      }
    },
    scrollTop() {
      // 获取html元素
      let htmlDom = document.getElementById("list");
      if (htmlDom.scrollTop !== 0) {
        this.topDistance -= 30;
        // 设置滚动行为改为平滑的滚动
        htmlDom.scrollTo({
          top: this.topDistance,
          behavior: "smooth",
        });
      }
    },
    // 获取滚动的高度
    handleScroll() {
      let htmlDom = document.getElementById("list");
      this.topDistance = htmlDom.scrollTop;
    },
  },
};
</script>

<style scoped>
.form-work-one {
  height: 100%;
  overflow: auto;
  background: #fff;
}
.regular-content {
  position: fixed;
  bottom: 100px;
  right: calc(10% - 10px);
}
.regular-content-item {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  text-align: center;
  margin-top: 20px;
  line-height: 40px;
  box-shadow: inset 0 0 5px rgb(63 77 201 / 10%),
    0 0 10px rgb(140 141 140 / 60%);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon-color {
  color: #386ed6;
  font-size: 1.12rem;
}
.monitor-list {
  background: #ff5e00;
  position: fixed;
  left: calc(10%);
  top: calc(100% / 2 - 100px);
  width: 120px;
  text-align: center;
  padding: 5px 0;
  border-radius: 4px;
}
.btn {
  cursor: pointer;
  font-size: 1.25rem;
  color: #ffffff;
  margin-bottom: 5px;
}
.btn:hover {
  color: #409eff;
}
.list-item {
  height: 30px;
  line-height: 30px;
  overflow-x: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.list-box {
  background: #ffffff;
  color: #333333;
  margin: 0 10px;
  font-size: 0.85rem;
  border-radius: 4px;
  padding: 10px 0;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  height: 240px;
}
.list {
  position: absolute;
  left: 0;
  top: 0;
  right: -17px;
  bottom: 0;
  overflow-x: hidden;
  overflow-y: scroll;
}
.list-item:hover {
  background: #fac29a;
}
.monitorClass {
  background: #fac29a;
}
</style>
